import React from 'react'
import astro from './astro.png'
import './home.css'
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import YouTubeIcon from '@mui/icons-material/YouTube';
import or from './in.jpg'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const App = () => {
  return (
    <div>
    <section>
        <div class = "container">
            <header>
                <a href="" class = "logo">Assignment 1</a>
                <ul>
                    <li><a href="#" class="active">Home</a></li>
                    <li><a href="#">About</a></li>
                    <li><a href="#">Team</a></li>
                </ul>
            </header>
            <div class="content">
                <h2>Home Page UI</h2>
                <p>Online recruitment solutions provide a centralized platform where all aspects of the hiring process can be managed, including job postings, applicant tracking, candidate evaluations, and communication. This streamlines the entire process and eliminates the need for manual handling of applications and paperwork.</p>
                <br/>
                <a href="#">Scroll Down</a> 

            </div>
            <div class="imgBx">
                <img src={astro}/>
            </div>
            <ul class="brand">
                <li><a href="https://github.com/MeetDOD"><GitHubIcon/></a></li>
                <li><a href="https://github.com/MeetDOD"><InstagramIcon/></a></li>
                <li><a href="https://meet-dodiya.web.app/"><LanguageIcon/></a></li>
                <li><a href="https://github.com/MeetDOD"><YouTubeIcon/></a></li>
            </ul>
        </div>
    </section>

      <div class="text-center">
                <h6 class="section-title bg-white text-center text-success px-3">Online recruitment</h6>
                <h1 class="mb-2">Key Features</h1>
            </div>

    <div  class="container-xxl">
        <div class="container">
            <div class="row g-4">
                <div class="col-lg-3 col-sm-6">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Job posting and distribution</h5>
                            <p>These platforms enable quick and easy job posting across multiple job boards, social media channels, and company websites.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Applicant tracking system (ATS)</h5>
                            <p> ATS is a fundamental component of online recruitment solutions that allows HR professionals and hiring managers to organize and manage candidate applications efficiently.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="ext-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Candidate screening tools</h5>
                            <p>Often include pre-screening assessments and customizable questionnaires that help filter candidates based on specific job requirements.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 ">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Collaboration and feedback</h5>
                            <p>HR professionals and hiring managers can share candidate profiles, provide feedback, and collectively make informed hiring decisions in real-time.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 ">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Interview scheduling and automation</h5>
                            <p>It become very easy and This reduces administrative burdens and makes coordination more efficient.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 ">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Data-driven insights</h5>
                            <p>These insights help HR professionals and hiring managers identify bottlenecks, optimize the process, and make data-driven decisions.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 ">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Candidate engagement and experience</h5>
                            <p>Online recruitment solutions often enhance candidate engagement, such as personalized communication, status updates, responses.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 ">
                    <div class="text-center pt-3" className='space'>
                        <div class="p-4">
                            <h5 class="mb-3">Compliance and data security</h5>
                            <p>These solutions are designed with data security and compliance in mind. provides secure data storage,gives the privacy & protection to candidate information.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      {/*  End Features of meetLearning*/}

      {/*  About Us card */}
    <div class="container-xxl">
        <div class="container" >
            <div class="row g-5">
                <div class="col-lg-6" >
                    <div class="position-relative h-100">
                        <img class="img-fluid position-absolute w-150 h-100" src={or}/>
                    </div>
                </div>
                <div class="col-lg-6">
                    <h6 class="bg-white text-start text-success pe-3">Online recruitment</h6>
                    <h1 class="mb-4">Summary</h1>
                    <p class="mb-4">An online recruitment solution greatly benefits hiring managers and HR professionals by streamlining the entire hiring process, providing robust applicant tracking, enhancing candidate engagement, offering data-driven insights, and ensuring compliance and data security. These efficiencies ultimately save time, reduce costs, and improve the overall quality of the recruitment process.</p>
                    <div class="row gy-2 gx-4 mb-4"> 
                        <div class="col-sm-6">
                        <p class="mb-0"><ArrowForwardIcon className='me-2'/>Job posting, distribution</p>
                        </div>
                        <div class="col-sm-6">
                        <p class="mb-0"><ArrowForwardIcon className='me-2'/>Applicant tracking</p>
                        </div>
                        <div class="col-sm-6">
                        <p class="mb-0"><ArrowForwardIcon className='me-2'/>Candidate screening</p>
                        </div>
                        <div class="col-sm-6">
                        <p class="mb-0"><ArrowForwardIcon className='me-2'/>Interview scheduling</p>
                        </div>
                        <div class="col-sm-6">
                        <p class="mb-0"><ArrowForwardIcon className='me-2'/>Collaboration, feedback</p>
                        </div>
                        <div class="col-sm-6">
                        <p class="mb-0"><ArrowForwardIcon className='me-2'/>Data-driven insights</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <div>
      <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
    <div class="col-md-4 d-flex align-items-center">
      <a href="/" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
        <svg class="bi" width="30" height="24"></svg>
      </a>
      <span class="text-muted">© 2023 , Meet Dodiya</span>
    </div>

    <ul class="nav col-md-4 justify-content-end list-unstyled d-flex mx-5">
      <li class="ms-3"><a class="text-muted" href="https://github.com/MeetDOD"><svg class="bi" width="24" height="24"><GitHubIcon/></svg></a></li>
    </ul>
  </footer>
    </div>

    </div>
  )
}

export default App
